import React from 'react';
import { convertEmoticons } from '../../utils/emoticons';

/**
 * Shared message text renderer.
 * - Converts text emoticons to emoji (e.g. ":)" → "😊")
 * - Highlights @mention tokens when participants are provided
 *
 * Props:
 *   text         - raw message text string
 *   participants - array of { member_id, name, isEveryone? }
 *                  If empty, no mention highlighting is applied.
 */
const MessageText = ({ text, participants = [] }) => {
  const converted = convertEmoticons(text || '');

  if (!participants.length) {
    return <>{converted}</>;
  }

  const sorted = [...participants].filter(p => p.name).sort((a, b) => b.name.length - a.name.length);
  const escaped = sorted.map(p => p.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const pattern = escaped.length
    ? new RegExp(`(@everyone|@(?:${escaped.join('|')}))`, 'g')
    : /(@everyone)/g;
  const parts = converted.split(pattern);

  return (
    <>
      {parts.map((part, i) =>
        part === '@everyone' || sorted.some(p => `@${p.name}` === part)
          ? <span key={i} className="font-semibold text-green-700 dark:text-green-400 bg-green-50 dark:bg-green-900/30 rounded px-0.5">{part}</span>
          : part
      )}
    </>
  );
};

export default MessageText;
